import React from "react";
import { Container, Row, Col } from "reactstrap";

const PageThree = () => {
  return (
    <Container fluid={true} className="main-body-container">
      <Row>
        <Col xs="1" md="1"></Col>
        <Col xs="10" md="6">
          <h2>
            You can visit them in the St. Jude Hall of Heroes VR app, where you can wander freely through the statues,
            float up for a closer look, and hear the personal stories behind each one.
          </h2>
        </Col>
        <Col xs="1" md="5"></Col>
      </Row>
      <Row>
        <Col xs="1" md="2"></Col>
        <Col xs="10" md="5">
          <h2>
            Each statue represents a story, a battle, a team, and at the center a young patient who fought for their
            life.
          </h2>
        </Col>
        <Col xs="1" md="5"></Col>
      </Row>
    </Container>
  );
};

export default PageThree;
